import React from 'react';
import ReportsPage from '../index';

const EmployeeReportsPage = () => (
  <ReportsPage isEmployee />
);
export default (EmployeeReportsPage);



// WEBPACK FOOTER //
// ./src/pages/travel-expense/reports/employee/index.js